import axios from 'axios'


const baseUrl =  'https://admin.gzxczx.org.cn'

const request = axios.create({
    baseURL: baseUrl, // 设置跨域代理接口统一的前置地址
    timeout: 10000,

})

// 添加请求拦截器
request.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
     let appKey = 'c0ee26b6-40fb-422e-9847-6acb6cd6e936'

    //通过拦截器统一添加appKey参数
    if(config.method==='get'){
        config.params.AppKey=appKey
    }else if(config.method==='post'){

        config.data.AppKey=appKey
    }

    return config
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
})



const get = (url, data) => request.get(url, {


    params: data
})

const post = (url, data) => request.post(url, data)

export default {

    get,
    post,
    baseUrl
}
